export default __webpack_public_path__ + "static/media/save.9176d853.jpg";